/* eslint-disable max-len */

import SushiQuestion from 'images/coin-pages/questions/sushi.svg'

import { ICoinPageData } from '../types'

export const sushiPage: ICoinPageData = {
  title: 'coin_931',
  description: 'coin_932',
  // description: 'coin_933',
  h1: (t, _, replacePlaceholders) => (
    <span
      dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Sushi Token' }) }}
    />
  ),
  questionsBlock: {
    image: SushiQuestion,
    questions: [
      {
        title: 'coin_934',
        answer: 'coin_935',
      },
      {
        title: 'coin_936',
        answer: 'coin_937',
      },
      {
        title: 'coin_938',
        answer: 'coin_939',
      },
      {
        title: 'coin_940',
        answer: 'coin_941',
      },
    ],
  },
  whatIs: {
    text: ['coin_944'],
    paragraphs: [
      {
        title: 'coin_942',
        text: ['coin_945'],
      },
      {
        title: 'coin_943',
        text: ['coin_946'],
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/what-is-crypto-lending-and-how-does-it-work/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/07/photo_2021-07-23_20-28-31.jpg',
        imageAlt: 'Sushi Token (SUSHI) review 5',
      },
      {
        link: 'https://coinrabbit.io/blog/how-crypto-assets-are-secured/',
        image: 'https://coinrabbit.io/blog/wp-content/uploads/2021/08/integration-52CR_LQ.png',
        imageAlt: 'Sushi Token (SUSHI) review 6',
      },
      {
        link: 'https://coinrabbit.io/blog/guide-to-short-selling-with-coinrabbit-bear-market-loans/',
        image: 'https://coinrabbit.io/blog/wp-content/uploads/2021/06/Bear-loans.png',
        imageAlt: 'Sushi Token (SUSHI) review 7',
      },
    ],
  },
}
